import axios from "axios";
import store from "../store/store";

/** HttpClient **/
export class HttpClient {
  static getUrl(url, data) {
    return this.baseUrl + this._serializeUrl(url, data);
  }
  static get(url, data) {
    return this._send("GET", this._serializeUrl(url, data));
  }
  static post(url, data) {
    return this._send("POST", url, data);
  }
  static put(url, data) {
    return this._send("PUT", url, data);
  }
  static delete(url, data) {
    return this._send("DELETE", this._serializeUrl(url, data));
  }
  static get baseUrl() {
    return "";
  }
  static async _send(method, url, data, headers, axiosConfig) {
    const response = await axios.request({
      ...axiosConfig,
      method,
      url,
      data,
      headers,
    });
    // Only require data attribute for success response
    return response.data;
  }
  static _serializeUrl(url, data) {
    let serializedUrl = url;
    if (data) {
      serializedUrl += `${url.includes("?") ? "&" : "?"}${new URLSearchParams(data).toString()}`;
    }
    return serializedUrl;
  }
}

/** WsApi: Public Wise Sync API Client **/
export class WsApi extends HttpClient {
  static _send(method, url, data, headers) {
    return super._send(method, url, data, headers, {
      baseURL: this.baseUrl,
    });
  }
  static get baseUrl() {
    return process.env.VUE_APP_ROOT_API;
  }
}

/** Secured Wise Sync API Client **/
export class SecuredWsApi extends WsApi {
  static _send(method, url, data, headers) {
    const securedHeaders = headers || {};
    if (store.state.jwt) {
      securedHeaders.Authorization = "Bearer " + store.state.jwt;
    }
    return super._send(method, url, data, securedHeaders);
  }
}
